<template>
    <div class="row">
        <div class="col-12">
            <div class="card">
                <div class="card-body">

                    <div class="form-group">
                        <label>Название</label>
                        <input type="text" v-model="form.name" class="form-control">
                    </div>

                    <button v-if="!loading" type="submit" class="btn btn-primary"
                        @click.prevent="addItem()">Создать</button>
                    <button v-else class="btn btn-primary" type="button" disabled>
                        <span class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
                        Отправка данных...
                    </button>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import log from '@/plugins/log'
import { to } from '@/plugins/utils'

export default {
    name: 'PartnerLayout',
    data: () => {
        return {
            form: {
                name: null
            },
            loading: false
        }
    },
    mounted() {
        log.debug('/views/partner/add', 'mounted')
    },
    methods: {
        async addItem() {
            if (!this.form.name) return $.NotificationApp.send("Ошибка", "Введите название", "top-right", "", "error")
            this.loading = true

            var [err, response] = await to(this.$http.post('/partner/add', this.form))
            if (err) {
                this.loading = false
                log.error('/views/partner/add', 'methods.addItem', '$http.request', err)
                return $.NotificationApp.send("Ошибка", err.message, "top-right", "", "error")
            }

            if (!response.data.success) {
                this.loading = false
                log.error('/views/partner/add', 'methods.addItem', '$http.response', response.data)
                return $.NotificationApp.send("Ошибка", response.data.error, "top-right", "", "error")
            }
            this.loading = false
            log.debug('/views/partner/add', 'methods.addItem', '$http.request', response.data)

            this.$router.push({
                name: 'PartnerEdit',
                params: {
                    id: response.data.id
                }
            })
        }
    }
};
</script>